import { ButtonNoStyle } from '@ui-components/utils.styles';
import React, { useState } from 'react';
import { SectionExpandArrow } from '../../DetailsPage/components/AssociatedContent/AssociatedContent.styles';
import { CookieConsentType } from '../CookieConsentType';
import { CookieConsentInfo } from '../cookieData';
import {
    StyledCookieConsentSwitchInput,
    StyledCookieSettingsGroup,
    StyledCookieSettingsGroupContent,
    StyledCookieSettingsGroupDetails,
    StyledCookieSettingsGroupDetailsDescription,
    StyledCookieSettingsGroupDetailsHeading,
    StyledCookieSettingsGroupDetailsSubHeading,
    StyledCookieSettingsGroupHeader,
    StyledCookieSettingsGroupHeading,
    StyledMessage,
} from './CookieSetting.styles';

type Props = {
    data: CookieConsentInfo;
    id: CookieConsentType;
    isCheckedBefore?: boolean;
    onChecked: (value: boolean, id: CookieConsentType) => void;
    defaultExpanded?: boolean;
};

type SwitchProps = {
    data: CookieConsentInfo;
    id: CookieConsentType;
    isCheckedBefore?: boolean;
    onChecked: (value: boolean, id: CookieConsentType) => void;
};

const SwitchInput = ({ data, id, onChecked, isCheckedBefore }: SwitchProps) => {
    const [isChecked, setChecked] = useState<boolean>(isCheckedBefore ? isCheckedBefore : false);
    if (data.required) {
        return <StyledMessage>Alltid aktiv</StyledMessage>;
    }

    return (
        <StyledCookieConsentSwitchInput
            inputName={`play_cookie_consent_${id}`}
            checked={isChecked}
            dataRt=""
            onChange={() => {
                const newValue = !isChecked;
                setChecked(newValue);
                onChecked(newValue, id);
            }}
            labelText={isChecked ? 'På' : 'Av'}
            a11yText={data.heading}
        />
    );
};

const CookieSetting = ({ data, id, isCheckedBefore, onChecked, defaultExpanded = false }: Props) => {
    const [expanded, setExpanded] = useState<boolean>(defaultExpanded);

    return (
        <StyledCookieSettingsGroup>
            <StyledCookieSettingsGroupHeader>
                <StyledCookieSettingsGroupHeading>
                    <ButtonNoStyle
                        type="button"
                        onClick={() => {
                            setExpanded(!expanded);
                        }}
                        aria-expanded={expanded}
                        aria-controls={`expandable-${id}`}
                    >
                        <SectionExpandArrow expanded={expanded} />
                        {data.heading}
                    </ButtonNoStyle>
                </StyledCookieSettingsGroupHeading>
                <SwitchInput data={data} id={id} onChecked={onChecked} isCheckedBefore={isCheckedBefore} />
            </StyledCookieSettingsGroupHeader>
            <StyledCookieSettingsGroupDetailsDescription expanded={expanded}>
                {data.subheading}
            </StyledCookieSettingsGroupDetailsDescription>
            <StyledCookieSettingsGroupContent id={`expandable-${id}`} expanded={expanded}>
                {data.details.map((details, i) => (
                    <StyledCookieSettingsGroupDetails key={`${id}-${i}`}>
                        <StyledCookieSettingsGroupDetailsHeading>
                            {details.heading}
                        </StyledCookieSettingsGroupDetailsHeading>
                        <StyledCookieSettingsGroupDetailsSubHeading>
                            {details.subheading}
                        </StyledCookieSettingsGroupDetailsSubHeading>
                    </StyledCookieSettingsGroupDetails>
                ))}
            </StyledCookieSettingsGroupContent>
        </StyledCookieSettingsGroup>
    );
};

export default CookieSetting;
